import { Col, Row } from 'react-bootstrap';
import Css from './Customer.module.css';

export default function InCome({ month_name = '', income = 0, awaiting = 0 }) {
    return (
        <div className={Css.Graph_Box + ' shadow'}>
            <div className={Css.Content + ' d-flex flex-column'}>
                <div className={Css.Header}>
                    <h6>รายได้เดือน {month_name} (Revenue)</h6>
                </div>
                <div className={Css.Content + ' d-flex flex-column flex-fill '}>
                    <Row className="mb-1 flex-fill">
                        <Col className="d-flex flex-column align-self-center">
                            <div className='flex-fill fs-4 text-success'>{income} ฿</div>
                            <div className="text-black-50">ชำระแล้ว (Earned)</div>
                        </Col>
                        <Col className="d-flex flex-column align-self-center">
                            <div className='flex-fill fs-4 '>{awaiting} ฿</div>
                            <div className="text-black-50">รอชำระ (Deferred)</div>
                        </Col>
                    </Row>
                </div>
            </div>
            <div className={Css.Footer + ' d-none'}>
                <a href={'#'}>View Full Plan</a>
            </div>
        </div>
    )
}